import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/models", label: "Models" },
  { to: "/apply", label: "Youth is yours" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const [pastHero, setPastHero] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const hidden = pathname === "/" && !pastHero && !open;
  return (
    <header data-testid="site-header" className={`fixed inset-x-0 top-0 z-50 border-b border-[#1c1418]/10 bg-white/85 backdrop-blur-xl transition-transform duration-500 ${hidden ? "-translate-y-full" : "translate-y-0"}`}>
      <div className="mx-auto flex h-20 max-w-[1400px] items-center justify-between px-5 md:px-10">
        <Logo />
        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}-link`}
              className="link-underline font-mono text-xs uppercase tracking-[0.25em] text-[#1c1418]/80 transition-colors hover:text-[#1c1418]">
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/apply" data-testid="header-apply-button"
            className="hidden items-center gap-2 rounded-full bg-[#1c1418] px-5 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-white transition-transform duration-300 hover:-translate-y-0.5 sm:flex">
            Apply now <ArrowUpRight className="h-4 w-4 text-[#e9458f]" />
          </Link>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen((o) => !o)} aria-label="Menu"
            className="grid h-10 w-10 place-items-center rounded-full border border-[#1c1418]/30 text-[#1c1418] md:hidden">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }}
            className="overflow-hidden border-t border-[#1c1418]/10 md:hidden" data-testid="mobile-menu">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                className="block border-b border-[#1c1418]/10 px-5 py-5 font-display text-4xl uppercase text-[#1c1418]">
                {l.label}
              </Link>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
